import styled from 'styled-components'
import { MoreVertical } from 'lucide-react'
import { BORDER_RADIUS, TRANSITIONS } from '../../../../styles/theme'

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: transparent;
  border: none;
  border-radius: ${BORDER_RADIUS.sm};
  cursor: pointer;
  transition: ${TRANSITIONS.all};
  opacity: 1;
`

export const StyledMoreIcon = styled(MoreVertical)<{ $isHovered: boolean }>`
  color: ${(props) =>
    props.$isHovered ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'};
  transition: ${TRANSITIONS.fast};
`
